import { Box, TextButton } from '@wix/design-system';
import React, { useEffect } from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { cycleSlug, getLowerCycleCtaKey } from './upsellCopyKeys';
export function SwitchToLowerCycle(_ref) {
  let {
    targetPricing,
    onSwitchCycle
  } = _ref;
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    t
  } = module.internals.useTranslations();
  const targetCycleId = targetPricing.cycleId;
  const componentName = `switch to ${cycleSlug(targetPricing.cycle)}`;
  useEffect(() => {
    module.internals.bi.onSwitchCycleComponentLoad == null || module.internals.bi.onSwitchCycleComponentLoad({
      componentName,
      targetCycle: targetCycleId
    });
  }, [module, componentName, targetCycleId]);
  if (!selectedCycle) {
    return null;
  }
  const ctaKey = getLowerCycleCtaKey(selectedCycle, targetPricing.cycle);
  return /*#__PURE__*/React.createElement(Box, {
    paddingTop: "SP3"
  }, /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    weight: "bold",
    as: "span",
    role: "button",
    wrap: true,
    style: {
      height: 'auto'
    },
    onClick: () => {
      module.internals.bi.onSwitchCycleComponentClick == null || module.internals.bi.onSwitchCycleComponentClick({
        targetCycle: targetCycleId,
        componentName
      });
      onSwitchCycle(targetCycleId);
    }
  }, t(ctaKey)));
}
//# sourceMappingURL=SwitchToLowerCycle.js.map